import {
  getCoupon,
  getMaskCoupon,
  getOpenCouponDataReport,
  getDataReportType,
} from './server/api'
import {
  AD_TYPE, AD_ACTINO_TYPE, WEB_AD, REPORT_TYPE
} from './utils/constant'
import {openEmbeddedMiniProgram, compareVersion} from './utils/utils'
import logger from './utils/logger'

const {windowWidth, model} = wx.getSystemInfoSync()
const menuInfo = wx.getMenuButtonBoundingClientRect()
const WXMLAD = {
  // 页面广告显示
  SHOWURLAD: 0, // 显示兜底广告
  SHOWAD: 1, // 显示默认广告
}

const maxMove = 500 // 全局变量-控制回弹得最大距离
let startX = 0 // 全局变量-储存手指触摸之后得横向移动距离
let startY = 0 // 全局变量-储存手指触摸之后得纵向移动距离

const ADTYPE = {
  // 广告入参
  URLAD: 1, // 显示兜底广告
  AD: 0, // 显示默认广告
}

// 根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
function getDirection(_startx, _starty, _endx, _endy) {
  const angx = _endx - _startx
  const angy = _endy - _starty
  let result = 0
  if (Math.abs(angx) < 10 && Math.abs(angy) < 10) return result // 如果滑动距离太短
  const angle = (Math.atan2(angy, angx) * 180) / Math.PI // 获得角度
  if (angle >= -135 && angle <= -45) result = 1
  else if (angle > 45 && angle < 135) result = 2
  else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
    result = 3
  } else if (angle >= -45 && angle <= 45) result = 4
  return result
}

const version = wx.getSystemInfoSync().SDKVersion || '1.1.0'

Component({
  properties: {
    haveNavBar: {
      type: Boolean,
      value: false,
    },
    serverUrl: {
      type: String,
      value: 'https://ad-server.51fubei.com/other/',
    },
    token: {
      type: String,
      value: '',
    },
    locName: {
      type: String,
      value: '',
    },
    openid: {
      type: String,
      value: '',
    },
    extendParam: {
      // 付呗专用参数
      type: [Object, Array, Number, String, Boolean],
    },
    isNeedStatistic: {
      // 是否需要组件内统计
      type: Boolean,
      value: true,
    },
    isShowAdPop: {
      // 广州深圳判断广告展示，false则兜底广告
      type: Boolean,
      value: true,
    },
  },
  data: {
    AD_TYPE,
    WXMLAD,
    appId: 'wxde69093658ce8aa8',
    homePath: '',
    couponPath: '',
    jumpMiniAppInfo: {
      appId: '',
      path: '',
      maskPath: '',
    },
    myCouponTotal: 0, // 我的优惠券总数
    menuInfo,
    isIpx:
      model.search('iPhone X') !== -1 ||
      model.search('iPhone13') > 1 ||
      model.search('iPhone 11') !== -1 ||
      false,
    coupon: [], // 页面优惠券列表
    curTab: 0, // 当前选中tab项
    scrollLeft: 0, // tab列表的横向滚动距离
    showMask: false, // 弹窗控制变量
    sign: '', // 弹窗券批量签名
    merchant: '', // 商户号
    empty: false, // 页面优惠券数据是否获取失败
    slidingDistance: 0, // 存储下拉回弹距离

    adUrl: '', // web广告
    isChangYi: -1,
    adType: -1,

    isPopAdWeb: false, // 三联web广告
    windowAdData: {
      adId: '',
      appId: '',
      appUrl: '',
      popImg: '',
      type: AD_TYPE.WX_SYNTHESIZE_POP,
    },

    // 三联广告曝光 列表
    listAdData: {
      adId: '',
      url: '',
      logo: '',
      mainTitle: '',
      subtitle: '',
      buttonName: '',
      type: AD_TYPE.WX_SYNTHESIZE_LIST,
    },
    // 三联广告曝光 banner
    bannerAdData: {
      bannnerImg: '',
      adId: '',
      url: '',
      type: AD_TYPE.WX_SYNTHESIZE_BANNER,
    },
    adImg: '', // 半屏小程序底图
    dataReportType: 1, // 曝光统计方式
  },
  lifetimes: {
    attached() {
      const {
        token, locName, openid, serverUrl, extendParam
      } = this.data

      if (extendParam && typeof extendParam !== 'string') {
        wx.showToast({icon: 'none', title: '请传入正确的参数格式'})
        return
      }
      if (
        !token ||
        !locName ||
        !openid ||
        !extendParam ||
        !JSON.parse(extendParam).adId ||
        !JSON.parse(extendParam).scene
      ) {
        wx.showToast({icon: 'none', title: '缺少必传参数'})
        return
      }

      wx._hwjShareData = {
        // 设置共享数据
        extendParam,
        serverUrl,
        token,
        loc_name: locName,
        openid,
      }

      // 场景值低版本兼容
      let scene = 1011
      if (compareVersion(version, '2.9.4') >= 0) {
        scene = wx.getEnterOptionsSync().scene
      }
      const shareList = [1007, 1008, 1044, 1096] // 点击分享进入小程序得渠道列表
      const isShareInto = shareList.indexOf(scene) <= -1 // true：不是分享渠道进入小程序
      this.setData({
        isShareInto, // 保存isShareInto变量xml调用
        homePath: `/pages/index/index?channel=${locName}`,
        couponPath: `/subpackages/coupon/coupon/coupon?id=0&channel=${locName}`,
      })
      this.reportType()
      if (isShareInto) this.getMaskCoupon() // 不是分享进入得需要获取弹窗
      // this.getCoupon()
    },
  },
  methods: {
    /**
     * @funcion 曝光统计纬度
     * @param e {Object} adEvent
     * @author by
     */
    async reportType() {
      try {
        const {locName} = this.data
        const res = await getDataReportType({
          loc_name: locName,
        })
        if (res) {
          this.setData({
            dataReportType: res.dataReportType
          })
        }
      } catch (error) {
        logger.error(`曝光方式${JSON.stringify(error)}`)
      }
    },
    /**
     * @funcion 曝光统计
     * @param reportInfo {Object} 曝光入参
     * @author by
     */
    async statisticJumSuc(reportInfo) {
      if (!this.data.isNeedStatistic) return
      try {
        const {
          isChangYi, token, locName, openid
        } = this.data
        const res = await getOpenCouponDataReport({
          is_chang_yi: isChangYi,
          token,
          locName,
          openid,
          ...reportInfo,
        })
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * @funcion 三联广告点击
     * @param e {Object} adEvent
     * @author by
     */
    popAdClick(e) {
      const reportInfo = {
        ad_id: '',
        action_type: AD_ACTINO_TYPE.click,
      }
      const type = e.detail
      switch (type) {
        case AD_TYPE.WX_SYNTHESIZE_POP:
          reportInfo.ad_id = this.data.windowAdData.adId
          this.openWxAd(AD_TYPE.WX_SYNTHESIZE_POP, reportInfo)
          break
        case AD_TYPE.WX_SYNTHESIZE_LIST:
          this.setData({
            adUrl: this.data.listAdData.url,
            isPopAdWeb: WEB_AD.SHOW,
          })
          reportInfo.ad_id = this.data.listAdData.adId
          this.statisticJumSuc(reportInfo)
          break
        case AD_TYPE.WX_SYNTHESIZE_BANNER:
          this.setData({
            adUrl: this.data.bannerAdData.url,
            isPopAdWeb: WEB_AD.SHOW,
          })
          reportInfo.ad_id = this.data.bannerAdData.adId
          this.statisticJumSuc(reportInfo)
          break
        default:
          console.log('数据不匹配')
          break
      }
    },
    bindscrolltolower() {
      // 触底函数
      this.setData({isBottom: true})
    },
    bindNavBack() {
      // 导航栏点击返回事件
      wx.navigateBack()
    },
    bindHGoHwjMiniprogram() {
      // 弹窗领券后跳转到好物集小程序
      const {appId, maskPath} = this.data.jumpMiniAppInfo
      wx.navigateToMiniProgram({
        appId: appId || this.data.appId,
        path: maskPath || this.data.homePath,
        envVersion: 'release',
        success(res) {
          console.log('跳转到小程序成功：', res)
        },
        fail(err) {
          console.log('跳转到小程序失败：', err)
        },
      })
    },
    getRpxToPx(rpx) {
      // rpx转换px
      return Math.floor((rpx / 750) * windowWidth)
    },
    bindChangeTab(e) {
      // 点击页面tab切换
      const curT = e.currentTarget
      this.setData({
        curTab: curT.dataset.id,
        scrollLeft:
          curT.offsetLeft > windowWidth - this.getRpxToPx(272)
            ? curT.offsetLeft
            : 0,
      })
    },
    async bindChangeSwiper(e) {
      // 手动左右滑动切换页面
      const curTab = e.detail.current
      this.setData({
        curTab,
        scrollLeft: curTab > 3 ? windowWidth * parseFloat(curTab / 5, 0) : 0,
      })
    },
    bindTouchStart(e) {
      // 触摸开始
      this.setData({slidingDistance: 0})
      startX = e.changedTouches[0].clientX
      startY = e.changedTouches[0].clientY
    },
    async bindTouchMove(e) {
      // 触摸移动中
      if (!this.data.isBottom) return
      const {clientX, clientY} = e.changedTouches[0]
      const direction = getDirection(startX, startY, clientX, clientY)
      if (direction === 3 || direction === 4) return // 如果左右滑动则禁止移动距离
      let y = maxMove
      if (clientY - startY <= maxMove) y = clientY - startY
      if (y > 0) return
      this.setData({slidingDistance: 0.3 * y}) // 为了清除卡顿问题，需要清除过渡效果, 移动系数0.3
    },
    async bindTouchEnd(e) {
      // 触摸结束-优惠券列表滚动到底部-切换下一个类目
      if (!this.data.isBottom) return
      this.setData({slidingDistance: 0}, () => {
        // 添加过渡效果
        const {clientX, clientY} = e.changedTouches[0]
        const direction = getDirection(startX, startY, clientX, clientY)
        const {curTab, coupon} = this.data
        if (direction === 1 && curTab < coupon.length - 1) {
          // 1:上拉
          const t = setTimeout(() => {
            clearTimeout(t)
            this.setData({curTab: curTab + 1, isBottom: false})
          }, 300)
        }
      })
    },
    bindCloseMask(e) {
      // 关闭弹窗
      console.log('弹窗点击回调', e)
      const data = {showMask: false}
      if (e.detail.success) {
        data.myCouponTotal =
          this.data.myCouponTotal + e.detail.coupon.length || 0
        this.data.coupon.forEach(function (item, index) {
          if (item.stocks && item.stocks.length) {
            item.stocks.forEach(function (stock, i) {
              e.detail.coupon.forEach(function (c) {
                if (c.stock_id === stock.stock_id) {
                  data[`coupon[${index}].stocks[${i}].ustatus`] = 1
                  data[`coupon[${index}].stocks[${i}].coupon_code`] =
                    c.coupon_code
                }
              })
            })
          }
        })
      }
      this.setData(data)
      if (e.detail.coupon) this.bindHGoHwjMiniprogram()
    },
    sendCouponCallback(e) {
      // 商家券领券回调
      console.log('页面领券回调', e)
      if (!e.detail.success) return
      if (e.detail.coupon && e.detail.coupon.length) {
        const i = this.data.coupon[this.data.curTab].stocks.findIndex(function (
          item
        ) {
          return item.stock_id === e.detail.coupon[0].stock_id
        })
        if (i > -1) {
          const stock = `coupon[${this.data.curTab}].stocks[${i}]`
          this.setData({
            [`${stock}.ustatus`]: 1,
            [`${stock}.coupon_code`]: e.detail.coupon[0].coupon_code,
            myCouponTotal: this.data.myCouponTotal + 1,
          })
        }
      }
    },
    /* eslint-disable */
    async getMaskCoupon() {
      // 获取弹窗优惠券
      const { token, locName, openid } = this.data
      const area_limit = this.data.isShowAdPop ? ADTYPE.AD : ADTYPE.URLAD //是否显示兜底广告 1 兜底
      const res = await getMaskCoupon({
        token,
        loc_name: locName,
        openid,
        area_limit,
      })
      if (!res) return
      console.log('弹窗接口返回数据', res)
      this.setData({
        maskCouponList: res.stocks || [],
        showMask: res.stocks && res.stocks.length,
        merchant: res.merchant,
        sign: res.sign,
        'jumpMiniAppInfo.maskPath': res.im_path,
      })
    },
    async getCoupon() {
      // 获取页面优惠券
      const { token, locName, openid } = this.data
      const area_limit = this.data.isShowAdPop ? ADTYPE.AD : ADTYPE.URLAD //是否显示兜底广告 1 兜底

      getCoupon({
        token,
        loc_name: locName,
        openid,
        area_limit,
      })
        .then((res) => {
          if (!res) throw Error

          const reportInfo = {
            action_type: AD_ACTINO_TYPE.exposure,
          }
          this.setData({
            coupon: res.data,
            tname: res.tname,
            myCouponTotal: res.total,
            'jumpMiniAppInfo.appId': res.appid,
            'jumpMiniAppInfo.path': res.jump_path,
            adUrl: res.ad_url,
            isChangYi: res.is_chang_yi,
            adType: res.type,
          })
          if (res.type === AD_TYPE.wxHalfAd) {
            const reportInfo = {
              ad_id: res.window_id,
              action_type: AD_ACTINO_TYPE.exposure,
            }
            this.setData({
              'windowAdData.adId': res.window_id,
              'windowAdData.appId': res.window_app_id,
              'windowAdData.appUrl': res.window_app_url,
              adImg: res.window_icon_list[0] || '',
            })
            this.openWxAd(AD_TYPE.wxHalfAd, reportInfo)
          }
          // 畅移曝光
          if (res.is_chang_yi) {
            this.statisticJumSuc({ ad_id: res.ad_id, ...reportInfo })
          }

          if (res.type !== AD_TYPE.WX_SYNTHESIZE_POP) return

          const bannerAd = JSON.parse(res.banner_ad) || ''
          const listAd = JSON.parse(res.list_ad) || ''
          this.setData({
            'windowAdData.adId': res.window_id,
            'windowAdData.appId': res.window_app_id,
            'windowAdData.appUrl': res.window_app_url,
            'windowAdData.popImg': res.window_icon_list[0],
            'listAdData.adId': listAd.id,
            'listAdData.logo': JSON.parse(listAd.icon)[0],
            'listAdData.url': listAd.url,
            'listAdData.mainTitle': listAd.mainTitle,
            'listAdData.subtitle': listAd.subtitle,
            'listAdData.buttonName': listAd.buttonName,
            'bannerAdData.adId': bannerAd.id,
            'bannerAdData.bannnerImg': JSON.parse(bannerAd.icon)[0],
            'bannerAdData.url': bannerAd.url,
          })
          // const banner_ad = JSON.parse(res.banner_ad) || ''
          //  三联 pop曝光
          if (res.window_id) {
            this.statisticJumSuc({ ad_id: res.window_id, ...reportInfo })
          }
          // 三联 列表曝光
          if (listAd.id) {
            this.statisticJumSuc({ ad_id: listAd.id, ...reportInfo })
          }
          // 三联 banner曝光
          if (bannerAd.id) {
            this.statisticJumSuc({ ad_id: bannerAd.id, ...reportInfo })
          }
        })
        .catch(() => this.setData({ empty: true }))
    },
    /**
     * @function: 打开小程序
     * @param {*} type 广告类型
     * @param {*} reportInfo 曝光入参
     * @author: by
     */
   async openWxAd(type, reportInfo) {
    try {
      const adState = await openEmbeddedMiniProgram(
        this.data.windowAdData.appId,
        this.data.windowAdData.appUrl
      )
      if(adState){
        // 广告曝光统计
        if (this.data.dataReportType === REPORT_TYPE.COMPLETE) {
          this.statisticJumSuc(reportInfo)
        } else if (adState.success) {
          this.statisticJumSuc(reportInfo)
        }
        logger.info(`广告${type}弹窗${adState.message}`)
      }
    } catch (error) {
      console.log(error);
    }
    
    },
    /**
     * @function 底图打开广告
     * @author: by
     */
   async clickAd() {
      const reportInfo = {
        ad_id: this.data.windowAdData.adId,
        action_type: AD_ACTINO_TYPE.click,
      }
      const adState = await openEmbeddedMiniProgram(
        this.data.windowAdData.appId,
        this.data.windowAdData.appUrl
      )
      if(adState){
        if (this.data.dataReportType === REPORT_TYPE.COMPLETE) {
          this.statisticJumSuc(reportInfo)
        } else if (adState.success) {
          this.statisticJumSuc(reportInfo)
        }
        logger.info(`广告${type}弹窗${adState.message}`)
      }
    },
  },
})
